/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getLikes.defs.js'
export * as $defs from './getLikes.defs.js'
